import { AxiosResponse } from 'axios';
import { getResponseAndContentType } from 'src/feature/Reports/Hooks/models';
import { filenameRegExp } from './constant';

export const downloadFilesOnBrowser = (response: AxiosResponse, fileFormat) => {
  const type = getResponseAndContentType(fileFormat || 'PDF');
  const disposition = response.headers['content-disposition'];
  const fileName = disposition?.match(filenameRegExp)?.[1];

  const downloadBlob = new Blob([response.data as BlobPart], {
    type: type.contentType,
  });

  const data = window.URL.createObjectURL(downloadBlob);
  const link = document.createElement('a');
  link.href = data;
  link.download = fileName || '';

  link.setAttribute('target', '_blank');
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);

  return 1;
};

export const printFileOnBrowser = (response: AxiosResponse, fileFormat) => {
  const type = getResponseAndContentType(fileFormat || 'PDF');
  // const disposition = response.headers['content-disposition'];
  // const fileName = disposition?.match(filenameRegExp)?.[1];

  const downloadBlob = new Blob([response.data as BlobPart], {
    type: type.contentType,
  });

  const data = window.URL.createObjectURL(downloadBlob);
  printPdfBlob(data);
  return 1;
};
export const printPdfBlob = (blobUrl: string) => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = blobUrl;
  document.body.appendChild(iframe);

  iframe.onload = function () {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();

    function cleanupIframe() {
      try {
        if (iframe.parentNode) {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
          window.removeEventListener('focus', handleFocusChange);
        }
      } catch (error) {
        console.log('Iframe already removed or error during cleanup:', error);
      }
    }

    const handleFocusChange = () => {
      setTimeout(() => {
        if (document.hasFocus()) {
          cleanupIframe();
          window.removeEventListener('focus', handleFocusChange);
        }
      }, 1000);
    };
    window.addEventListener('focus', handleFocusChange);
  };
};
